import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: 'deleteCoupon',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteCoupon($ids: [String]!) {
        deleteCoupon(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
